import { isConnectionsV2Enabled } from '@/config/connectionsV2';

const connectionsHubEntry = {
  title: 'Connections hub',
  to: 'settings-connections-hub',
  action: 'read',
  subject: 'Management',
  isNeedBusinessProfile: true,
  icon: { icon: 'lucide:layout-grid' },
  envOnly: 'development',
};

// The dev-only hub is retired once Connections v2 is on (its URLs redirect, see the router).
const connectionsHub = isConnectionsV2Enabled() ? [] : [connectionsHubEntry];

export default [
  {
    title: 'Settings',
    icon: { icon: 'ic:outline-settings' },
    action: 'read',
    subject: 'User',
    children: [
      {
        title: 'My Profile',
        to: 'settings-profile',
        action: 'read',
        subject: 'User',
        icon: { icon: 'mdi-account-outline' },
      },
      {
        title: 'Business Profile',
        to: 'settings-business-profile',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'mdi-briefcase-outline' },
      },
      {
        title: 'Connections',
        to: 'settings-connections',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'icon-park-outline:connection-point' },
      },
      ...connectionsHub,
      {
        title: 'Data Status',
        to: 'settings-data-status',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'lucide:activity' },
        envOnly: 'development',
      },
      {
        title: 'eBay (dev)',
        to: 'integrations-ebay',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'lucide:shopping-bag' },
        envOnly: 'development',
      },
      {
        title: 'Shopify (dev)',
        to: 'integrations-shopify',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'lucide:store' },
        envOnly: 'development',
      },
      {
        title: 'Walmart (dev)',
        to: 'integrations-walmart',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'lucide:shopping-cart' },
        envOnly: 'development',
      },
      {
        title: 'Google (dev)',
        to: 'integrations-google',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'lucide:globe' },
        envOnly: 'development',
      },
      {
        title: 'TikTok Ads (dev)',
        to: 'integrations-tiktok',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'lucide:music' },
        envOnly: 'development',
      },
      {
        title: 'Pinterest (dev)',
        to: 'integrations-pinterest',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'lucide:pin' },
        envOnly: 'development',
      },
      {
        title: 'Meta (dev)',
        to: 'integrations-meta',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'lucide:infinity' },
        envOnly: 'development',
      },
      {
        title: 'Microsoft Ads (dev)',
        to: 'integrations-bing',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'lucide:search' },
        envOnly: 'development',
      },
      {
        title: 'Users',
        to: 'settings-invites',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'material-symbols:group-add-outline-rounded' },
      },
      {
        title: 'Notifications',
        to: 'settings-notifications',
        action: 'read',
        subject: 'User',
        icon: { icon: 'mdi:bell-outline' },
        envOnly: 'development',
      },
      {
        title: 'Plans & Billing',
        to: 'billing',
        action: 'read',
        subject: 'Management',
        icon: { icon: 'uil:bill' },
      },
    ],
  },
];
